import SubTabs from 'components/sub-tabs';
import React from 'react';
import { useIntl } from 'react-intl';
import { SiteTab } from 'views/site-settings/types/site-tab.type';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
  aSites: number;
  iSites: number;
  oSites: number;
};

const SitesSubTabs: React.FC<Props> = ({ aSites, iSites, oSites }) => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'siteSettings.listSites';

  return (
    <SubTabs
      tabs={[
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.sitesLabel` }, { value: aSites }),
          value: SiteTab.ACTIVE,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.inactiveSitesLabel` }, { value: iSites }),
          value: SiteTab.INACTIVE,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.sitesWithoutErpIdLabel` }, { value: oSites }),
          value: SiteTab.SITES_WITHOUT_MAPPING,
        },
      ]}
    />
  );
};

export default React.memo(SitesSubTabs);
